export const ACCOUNT_COOKIE = 'userData';



// WEBPACK FOOTER //
// ./src/settings/account.js